import * as React from 'react';
import { IContext } from '../../../../shared/store';
import { CommercialOfferCardPageContainer } from '../../../../shared/components/offer_card_page.commercial/container';
import { OfferCardPageContainer } from '../../../../shared/components/offer_card_page/container';

export function getOfferCardPage(offerType: string, context: IContext) {
  if (offerType === 'commercial') {
    return <CommercialOfferCardPageContainer context={context} />;
  }

  return <OfferCardPageContainer context={context} />;
}
